import { createActions } from 'redux-actions';

const actions = createActions({
  APP_NAV: {
    SET_COLLAPSE: (collapse) => ({ collapse }),
    TOGGLE_IS_OPEN: (isOpen) => ({ isOpen })
  },
  HOME_NAV: {
    SET_TRANSPARENT: (transparent) => ({ transparent })
  }
});

export default actions;



// WEBPACK FOOTER //
// ./src/state/modules/navbar/actions.js